import { Grid } from "@mui/material";
import useStyles from "../styles";
import { useEffect, useState } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import Button from "../../../components/Button/Button";
import { useParams } from "react-router-dom";
import { httprequest } from "../../../data/api";
import { ToastContainer, toast } from "react-toastify";
import useValidator from "../../../hooks/useValidator";
import InputGroup from "../../../components/FormComponent/InputGroup";

// --STAFF ENDPOINT
const STAFF_PROFILE = "/admin/v1/teacher";

const StaffProfile = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [staffValidator, showStaffValidator] = useValidator();
  const [isloading, setIsLoading] = useState(false);
  // const [profiledetails, setProfileDetails] = useState({
  //   // first_name: data?.first_name
  // });
  const [editprofiledtails, setEditProfileDetails] = useState({
    first_name: "",
    last_name: "",
    email: "",
    role: ""
  });

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setEditProfileDetails({ ...editprofiledtails, [name]: value });
  };

  // Request for a Staff Information by ID
  const handleGetStaffProfile = () => {
    setIsLoading(true);
    httprequest.get(`${STAFF_PROFILE}/${id}`).then((res) => {
      // eslint-disable-next-line no-console
      console.log(res?.data);
      setEditProfileDetails({ ...editprofiledtails,
        first_name: res?.data?.data?.first_name,
        last_name: res?.data?.data?.last_name,
        email: res?.data?.data?.email,
        role: res?.data?.data?.role
      });
      // eslint-disable-next-line no-console
      console.log(res.data);
    }).catch((err) => {
      setIsLoading(false);
      toast.error(err?.response.data);
    });
  };

  // To Edit/Update Staffs Profile
  const handleUpdateStaffProfile = () => {
    if (staffValidator.allvalid()) {
      setIsLoading(true);
      httprequest.patch(`${STAFF_PROFILE}/${id}`, editprofiledtails).then((res) => {
        setIsLoading(false);
        toast.success(res?.data.message);
        setEditProfileDetails({ ...editprofiledtails, first_name: "", last_name: "", email: "", role: "" });
      }).catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data);
      });
    } else {
      showStaffValidator(true);
    }
  };

  const [file, setFile] = useState();

  const handleChange = (event) => {
    setFile(event.target.files[0]);
  };

  useEffect(() => {
    handleGetStaffProfile();
  }, []);

  const { first_name, last_name, email, role } = editprofiledtails;

  return (
    <>
      <Grid container spacing={4}>
        <Grid item lg={3} md={4} sm={12} xs={12}>
          <div className="left-container">
            <h4>Personal Information</h4>
            <h6>Update your personal details here</h6>
            <div className={classes.profilecontainer}>
              <div className={classes.imageviewer}>
                <div className={classes.pickercontainer}>
                  <input type="file" name="profile_picture" value={file} className={classes.profilepicker} onChange={handleChange} />
                  <CameraAltIcon className={classes.camera} />
                </div>
              </div>
            </div>
            <Button
              variant="primaryoutline"
              buttonSize="full"
              color="btnfontprimary"
              buttonName="Off board Employee"
            />
          </div>
        </Grid>
        <Grid item lg={9} md={8} sm={12} xs={12}>
          <div className="right-container padding-all">
            <Grid container spacing={2} className={classes.profileform}>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="First Name" inputName="first_name" value={first_name} onChange={handleProfileChange} />
                {staffValidator.message("First Name", first_name, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Last Name" name="" value={last_name} onChange={handleProfileChange} />
                {staffValidator.message("Last Name", last_name, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Email Address" name="" value={email} onChange={handleProfileChange} />
                {staffValidator.message("Email Address", email, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Gender" name="" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Phone Number" name="" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Country" name="" />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup inputType="text" label="Role" name="" value={role} onChange={handleProfileChange} />
                {staffValidator.message("Role", role, "required")}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup inputType="text" label="Reporting to" name="" />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup inputType="text" label="Home Address" name="" />
              </Grid>
            </Grid>
            <div className={classes.btnspace}>
              <Button variant="primary" color="btndefault" buttonSize="medium" buttonName="Save Changes" isloading={isloading} onClick={handleUpdateStaffProfile} />
            </div>
          </div>

        </Grid>
        <ToastContainer />
      </Grid>
    </>
  );
};

export default StaffProfile;
